var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isLoggedIn)?_c('LoginPage',{on:{"login-success":_vm.onLoginSuccess}}):_c('AppLayout',{on:{"logout":_vm.onLogout}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }